import Vue from 'vue'
import VueRouter from 'vue-router'

import ExamplePage from './components/ExamplePage.vue'
import RedirectSSOPage from './components/RedirectSSOPage.vue'
import SaveTokenFromSSOPage from './components/SaveTokenFromSSOPage.vue'
import PrivatePage from './components/PrivatePage.vue'
import NotificationPage from './components/NotificationPage.vue'
import PdfPage from './components/PdfPage.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        { path: '/', component: ExamplePage },
        { path: '/redirectSSO', component: RedirectSSOPage },
        { path: '/saveTokenSSO', component: SaveTokenFromSSOPage },
        { path: '/private', component: PrivatePage },
        { path: '/notification', component: NotificationPage },
        { path: '/pdf', component: PdfPage }
    ]
})

export default router;